<div class="modal-container">
  <div class="modal-content">
    <!-- Encabezado del Modal -->
    <div class="modal-title d-flex justify-content-end">
      <!-- Botón de cierre -->
      <div class="button-x justify-content-end d-flex">
        <img
          class="cursor-pointer pr-4"
          src="assets/image/modal/close-modal.svg"
          alt="Cerrar"
          width="19px"
          (click)="closeDialog()"
        />
      </div>
    </div>

    <!-- Contenido del Modal -->
    <div class="content-message d-flex align-items-center justify-content-center hp-100">
      <div class="ta-c w-100 py-24 ta-c">
        <!-- Icono -->
        <div class="ta-c img-password" *ngIf="dataRecieved?.icon">
          <img src="{{dataRecieved.icon}}" alt="alert">
        </div>

        <!-- Título -->
        <div class="pt-16">
          <div class="headingMessage">{{ dataRecieved?.title }}</div>
        </div>

        <!-- Descripción -->
        <div class="align-items-center message-alert-container">
          <span class="message-alert font-regular" [innerHTML]="dataRecieved?.description">
            {{ dataRecieved?.description }}
          </span>
        </div>

        <!-- Botón -->
        <div *ngIf="dataRecieved?.button" class="mt-24 d-flex content-button justify-content-center">
          <button mat-flat-button color="accent" class="font-bold-dali ph-24 vw-100 error-btn" (click)="closeDialog()">
            <span [innerHTML]="dataRecieved?.textButton"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 